import apiClient from "@/utils/apiClient";
import {fetchDocuments, showAlertModal} from "@/utils/utils";

export default {
    data() {
        return {
            files: null,
        }
    },
    async created() {
        this.locationId = this.$route.params.locationId ? this.$route.params.locationId : this.location.id;
        this.files = await fetchDocuments(this.locationId, this);
    },
    methods: {
        // this method is used for uploading files to the back-end
        async updateFiles() {
            try {
                await apiClient.put("/api/locations/" + this.locationId + "/documents/", this.files);
                this.files = await fetchDocuments(this.locationId, this);
                showAlertModal(this.$store, 'Fișierele au fost actualizate cu succes.', 'success', 2000);
            } catch (error) {
                console.error('Error updating files:', error.response ? error.response.data : error.message);
                showAlertModal(this.$store, 'A intervenit o eroare la actualizarea fișierelor.', 'danger', 12000, error);
            }
        },
    },
    watch: {
        /**
         * Watches the 'files' data property for changes.
         * When 'files' changes, this watcher updates the session storage with the new files data,
         * associating it with the current location ID.
         */
        files: {
            handler: function (newFiles) {
                sessionStorage.setItem(
                    "files" + this.locationId,
                    JSON.stringify(newFiles)
                );
            },
            deep: true,
        },
    }
}